var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 4.222,
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21.222,
    width: 62,
    height: 4.222,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25.444,
    width: 62,
    height: 4.222,
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 29.666,
    width: 62,
    height: 4.222,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 33.888,
    width: 62,
    height: 4.222,
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 38.11,
    width: 62,
    height: 4.222,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 42.332,
    width: 62,
    height: 4.222,
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 46.554,
    width: 62,
    height: 4.222,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 50.776,
    width: 62,
    height: 4.222,
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 28.5,
    height: 21.11,
    fill: "#0D5EAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25.444,
    width: 28.5,
    height: 4.222,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.139,
    y: 17,
    width: 4.222,
    height: 21.11,
    fill: "#FFFFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.33dd1d863924b17b18a6ee899b5c8286.svg";
export { ForwardRef as ReactComponent };